module.exports = __webpack_public_path__ + "tg.e0f44835.svg";